module.exports = __webpack_public_path__ + "img/redEnvelopedRainTipImage.fbd8a720.png";